import { render, staticRenderFns } from "./MoleculeModalRowText.vue?vue&type=template&id=23aa07ae&"
import script from "./MoleculeModalRowText.vue?vue&type=script&lang=js&"
export * from "./MoleculeModalRowText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports